import { useLocation, useNavigate } from "react-router-dom";
import { HeaderItems, NavItemTooltipItems } from "../../constant/data";
import { FiUser } from "react-icons/fi";
import { Fragment, useState } from "react";
import { Button } from "../forms";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { Menu, Transition } from "@headlessui/react";
import Wizardbg from "./WizardModebg";

const NavItems = () => {
  const path = useLocation().pathname;
  var pathname = path.substring(path.lastIndexOf("/") + 1);
  const navigate = useNavigate();

  const { showWizard, authuser, SelectedOrg } = useStateGetter();

  const { setShowwiz , setBreadTitle,setAuthuser,setConfig} = useStateSetter();
  const menu_items = [
    { title: "Profile", url: "/profile" },
    { title: "Preference", url: "/preference" },
  ];
  const [activetooltip, setactivetooltip] = useState("wizard");
  const logout = () => {
    localStorage.clear();
  
    navigate("/");

   window. location.reload()
  };


  const skip=()=>{

    setShowwiz(false);
    localStorage.setItem("ShowWizard", JSON.stringify(false));

  }
  return (
    <div className=" relative flex p-1 justify-center items-center  text-gray-500">
         {/* Tour guide wizard to show new users around */}
         {showWizard && (
        <Wizardbg skip={skip} active={activetooltip} control={setactivetooltip} />
      )}
      {HeaderItems.map((item, key) => (
        <div
          onClick={() => {
            
            navigate(item.path);

            setBreadTitle(item.title)
          }}
          className={`flex flex-col  h-[12vh]   ${
            pathname.includes(item.title.toLowerCase())
              ? "border-primary border-b-2  "
              : ""
          } justify-center items-center m-2 gap-2`}
        >
          <p
            className={`text-[20px] ${
              pathname.includes(item.title.toLowerCase())
                ? "!text-primary !font-bold"
                : ""
            }`}
          >
            {" "}
            {item.icon}
          </p>
          <p
            className={`text-xs font-medium  cursor-pointer ${
              pathname.includes(item.title.toLowerCase())
                ? "!text-primary !font-bold"
                : ""
            }`}
          >
            {item.title}
          </p>
          {/* Show  initial setup guide wizard for each nav item  */}
          {showWizard && (
            <div
              className={` absolute flex flex-col justify-center  px-3 pt-4 top-16 tooltipitem   self-end    ${
                activetooltip.toLowerCase() == item.title.toLowerCase()
                  ? "  "
                  : "hidden"
              }`}
            >
              <p className="text-sm font-bold text-textbg">
                {NavItemTooltipItems[key].title}
              </p>
              <p className="text-xs font-light text-textbg">
                {NavItemTooltipItems[key].desc}
              </p>
              <div className="px-3">
                <div className=" flex justify-center  cust items-center w-full gap-6">
                  <Button
                    style={"   bg-white !border-[#aaaaaa] border !text-textbg"}
                    text="Skip"
                    onBtnClick={ skip}
                  />

                  <Button
                    text={`Next (${key + 1} of ${
                      NavItemTooltipItems.length
                    })`}
                    onBtnClick={() => {
                      setactivetooltip(NavItemTooltipItems[key + 1].title);
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      ))}

      <Menu as="div" className="relative">
        <div>
          <Menu.Button className="ml-2  flex text-sm rounded-full focus:outline-none focus:ring-1 focus:ring-neutral-400">
            <div className=" p-1 flex relative bg-gray-100 m-2 rounded-full justify-center items-center">
              <FiUser size={20} />
            </div>
          </Menu.Button>
        </div>

        {showWizard && (
          <div
            className={` absolute flex flex-col justify-center  px-3 pt-4 top-10 tooltipitem   right-0   ${
              activetooltip.toLowerCase() == "account" ? "  " : "hidden"
            }`}
          >
            <p className="text-sm font-bold text-textbg">
              {NavItemTooltipItems[5].title}
            </p>
            <p className="text-xs font-light text-textbg">
              {NavItemTooltipItems[5].desc}
            </p>
            <div className="px-3">
              <div className=" flex justify-center  cust items-center w-full gap-6">
                <Button
                  style={"   bg-white !border-[#aaaaaa] border !text-textbg"}
                  text="Skip"
                  onBtnClick={skip}
                />

                <Button
                  text={`Done 6 of ${NavItemTooltipItems.length})`}
                  onBtnClick={ skip}
                />
              </div>
            </div>
          </div>
        )}
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="origin-top-right z-10 absolute right-0 mt-2 w-48 rounded-sm shadow-md p-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
            <Menu.Item>
              <div className="p-3 bg-black flex rounded-lg ">
                <div>
                  <img src="/images/avatar.png" alt="" />
                </div>
                <div className="   text-white">
                  {" "}
                  <p className="text-sm m-2 font-light">
                    Hello {authuser && authuser.firstName}
                  </p>
                  <p className="text-xs mr-2 font-light text-ellipsis overflow-hidden   ">
                    {authuser && authuser.email}
                  </p>
                </div>
              </div>
            </Menu.Item>

          
            <Menu.Item>
              {({ active }) => (
                <button
                  className={
                    " w-full active:bg-gray-200 hover:bg-faint rounded-sm px-4 py-2 text-gray-700 cursor-pointer focus:bg-faint  text-sm text-left "
                  }
                  onClick={() => {}}
                >
                  Profile
                </button>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <button
                  className={
                    "w-full active:bg-gray-200 rounded-sm px-4 py-2 text-gray-700 cursor-pointer focus:bg-faint   hover:bg-faint text-sm text-left"
                  }
                  onClick={logout}
                >
                  Log out
                </button>
              )}
            </Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};

export { NavItems };
